import noUiSlider from 'nouislider';
import LocationSearch from './_location_search';

( function( app ) {
  const COMPONENT = {
    init: function() {
      $( 'button.easy-toggle-slide-toggle' ).on( 'toggleBefore', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        const targetArray = target.split( ', ' );
        $.each( targetArray, function( index, target ) {
          if ( target != 'body' && target != '.navbar' && target != '#scrim-overlay' ) {
            $( target ).slideToggle();
          }
        } );
      } );

      $( document ).on( 'click', '.js-init-video, .wp-block-click-to-play a', function( e ) {
        e.preventDefault();

        let videoUrl = $( this ).attr( 'href' );
        let autoplayMatch = videoUrl?.match( /[?&]autoplay=([01])/ ) || ['autoplay=0'];
        autoplayMatch = autoplayMatch[0].replace( /[?&]/, '' );
        videoUrl = videoUrl.replace( /([?&])autoplay=[01](&|$)/, '$1' ).replace( /\?$/, '' );

        $.magnificPopup.open( {
          items: {
            src: videoUrl,
          },
          type: 'iframe',
          iframe: {
            markup: `
              <div class="mfp-iframe-scaler">
                <div class="mfp-close"></div>
                <iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>
              </div>
            `,
            patterns: {
              youtube: {
                index: 'youtube.com/',
                id: 'v=',
                src: `//www.youtube.com/embed/%id%?${autoplayMatch}`,
              },
              vimeo: {
                index: 'vimeo.com/',
                id: '/',
                src: `//player.vimeo.com/video/%id%?${autoplayMatch}`,
              },
              gmaps: {
                index: '//maps.google.',
                src: '%id%&output=embed',
              },
            },
            srcAction: 'iframe_src',
          },
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false,
          callbacks: {
            open: function() {
              $( 'video' ).trigger( 'pause' );
            },
            close: function() {
              $( 'video' ).trigger( 'play' );
            },
          },
        } );
      } );

      $( document ).on( 'click', '.js-back', ( e ) => {
        if ( window.history.length > 1 && document.referrer.indexOf( window.location.host ) !== -1 ) {
          e.preventDefault();
          window.history.back();
        }
      } );

      if ( document.referrer.indexOf( window.location.host ) !== -1 ) {
        $( '.js-back' ).attr( 'href', document.referrer );
      }

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      $( '#mpf-back' ).on( 'click', function( e ) {
        e.preventDefault();
        $( '.gform_page_footer .gform_previous_button' ).trigger( 'click' );
      } );

      $( document ).on( 'submit', '.form-skin', function() {
        // Disable submit button
        $( this ).find( 'button[type="submit"]' ).prop( 'disabled', true ).css( 'opacity', 0.2 );
      } );

      /* Primary button */
      $( '.btn-primary, .single_add_to_cart_button, .gform_next_button, .ll-wocommerce .button, .button.wc-forward, .restore-item, .woocommerce-form-coupon .form-row-last button, .lost_reset_password .woocommerce-Button, .woocommerce-MyAccount-content a.button, .woocommerce button.button, .bag_sidebar-link a' )
          .on( 'mouseenter', function( e ) {
            const parentOffset = $( this ).offset();
            const relX = e.pageX - parentOffset.left;
            const relY = e.pageY - parentOffset.top;
            $( this )[0].style.setProperty( '--primaryTop', `${relY}px` );
            $( this )[0].style.setProperty( '--primaryLeft', `${relX}px` );
          } )
          .on( 'mouseout', function( e ) {
            const parentOffset = $( this ).offset();
            const relX = e.pageX - parentOffset.left;
            const relY = e.pageY - parentOffset.top;
            $( this )[0].style.setProperty( '--primaryTop', `${relY}px` );
            $( this )[0].style.setProperty( '--primaryLeft', `${relX}px` );
          } );

      LocationSearch.init();
    },
    finalize: function() {
      if ( typeof gform !== 'undefined' ) {
        gform.addFilter( 'gform_spinner_target_elem', function( $targetElem, formId ) {
          return $targetElem.closest( '.data-content' );
        } );
      }

      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        $( '#mpf-back' ).toggle( currentPage > 1 );
        const $pageElement = $( `#gform_page_${formId}_${currentPage}` );
        $( '.gf_progressbar_percentage span' ).insertAfter( $( '.gf_progressbar' ) );
        $pageElement.find( '.range-slider' ).each( function( key, el ) {
          const input = $( el ).find( 'input' );
          const slider = $( el ).find( '.noui-range-slider' ).get( 0 );
          const label = $( el ).find( '.gfield_label' ).get( 0 );
          const range = {min: parseInt( input.attr( 'min' ) ) || 0, max: parseInt( input.attr( 'max' ) ) || 0};
          noUiSlider.create( slider, {
            start: 2560,
            connect: 'lower',
            step: 20,
            format: {
              to: function( value ) {
                return Math.round( value ).toLocaleString();
              },
              from: function( value ) {
                return value;
              },
            },
            range: {
              'min': range.min,
              'max': range.max,
            },
            pips: {
              mode: 'positions',
              values: [0, 100],
              density: range.max,
              format: {
                to: function( value ) {
                  return Math.round( value ).toLocaleString();
                },
              },
            },
          } );

          slider.noUiSlider.on( 'update', function( values, handle ) {
            input.value = values[handle];
            label.innerText = input.attr( 'placeholder' ).replace( `{value}`, values[handle] );
            setTimeout( () => {
            }, 0 );
          } );
        } );
      } );

      $( document ).on( 'gform_confirmation_loaded', function() {
        $( '#mpf-back' ).hide();
      } );

      $( document ).on( 'gform_post_render', function( event, formId, currentPage ) {
        const $form = $( `#gform_${formId}` );
        if ( $form.length > 0 ) {
          const locationSelects = $form.find( '.location-select select' );
          if ( locationSelects.length > 0 ) {
            let preferredLocation = LocationSearch.getPreferredLocation();
            if ( !preferredLocation ) {
              preferredLocation = utmLocation.getLocation();
            }

            if ( preferredLocation ) {
              const storeId = preferredLocation.store_id || preferredLocation.store_code;
              locationSelects.each( function( index, element ) {
                const $select = $( element );
                const $option = $select.find( `option[value="${storeId}"]` );
                if ( $option.length > 0 ) {
                  $select.val( storeId );
                  $select.trigger( 'change' );
                }
              } );
            }
          }
        }
      } );

      document.addEventListener( 'click', function( e ) {
        if ( e.target.matches( '.js-selected-location-toggle' ) ) {
          $( 'button[data-toggle-target="#scrim-overlay, #flyout__find-a-store"]' ).trigger( 'click' );
        }
      } );
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
